import { api } from "@/lib/api";

export const BELT_COLORS = {
  White: "#efe9d8", Yellow: "#ffd54a", Orange: "#ff8c2e", Green: "#3f9d4e",
  Blue: "#2f6fd0", Purple: "#7a4fd3", Brown: "#8a5a2e", Black: "#1a1a1a",
};

export const BELT_INK = { White: "#113d40", Yellow: "#3a2c00", Orange: "#3a1a00", Green: "#0d2e14", Blue: "#0c2447", Purple: "#2a1247", Brown: "#2e1c0a", Black: "#f5f1e6" };

export const academyApi = {
  overview: () => api.get("/academy/overview").then((r) => r.data),
  glossary: () => api.get("/academy/glossary").then((r) => r.data),
  resources: () => api.get("/academy/resources").then((r) => r.data),
  me: () => api.get("/academy/me").then((r) => r.data),
  register: (data) => api.post("/academy/register", data).then((r) => r.data),
  login: (data) => api.post("/academy/login", data).then((r) => r.data),
  logout: () => api.post("/academy/logout").then((r) => r.data),
  dashboard: () => api.get("/academy/dashboard").then((r) => r.data),
  lesson: (id) => api.get(`/academy/lessons/${id}`).then((r) => r.data),
  markRecall: (id) => api.post(`/academy/lessons/${id}/recall`).then((r) => r.data),
  practice: (lessonId, qid, choiceId) => api.post(`/academy/lessons/${lessonId}/practice/${qid}`, { choiceId }).then((r) => r.data),
  startSection: (lessonId) => api.post(`/academy/lessons/${lessonId}/assessment/start`).then((r) => r.data),
  startBeltExam: (beltId) => api.post(`/academy/belts/${beltId}/exam/start`).then((r) => r.data),
  startFinal: () => api.post("/academy/final/start").then((r) => r.data),
  submitExam: (attemptId, answers) => api.post(`/academy/exams/${attemptId}/submit`, { answers }).then((r) => r.data),
  submitWritten: (lessonId, text) => api.post(`/academy/written/${lessonId}`, { text }).then((r) => r.data),
  submitLab: (labId, text) => api.post(`/academy/labs/${labId}`, { text }).then((r) => r.data),
  careers: (data) => api.post("/academy/careers", data).then((r) => r.data),
  verify: (token) => api.get(`/academy/verify/${token}`).then((r) => r.data),
};
